import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const FuelIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1 2H19.1C19.7 2 20.1 2.5 20.1 3V18.3C20.1 18.9 19.6 19.3 19.1 19.3H7.20001C6.60001 19.3 6.20001 18.8 6.20001 18.3V8.7C6.20001 8.5 6.20001 8.2 6.40001 8.1L9.90001 4.5C10.1 4.2 10.4 4.1 10.7 4.1H11.5C11.9 4.1 12.2 3.9 12.4 3.6L13.1 2.5C13.3 2.2 13.6 2 14 2H14.1Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11.1 4.1H16.1C16.3 4.1 16.5 4 16.6 3.8L17.7 2"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M9.38974 5.16569L6.98558 7.56985L5.85421 6.43848C5.64207 6.22635 5.57136 5.87279 5.85421 5.58995L7.48055 3.9636C7.69268 3.75147 8.04624 3.68076 8.32908 3.9636L9.46045 5.09497L9.38974 5.16569Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11.1 14H15.5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11.1 9.6H15.5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15.5 14V9.6"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11.1 9.6V14"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.2 14.9L11.1 14"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M16.3 8.8L15.5 9.6"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11.1 9.6L10.2 8.8"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15.5 14L16.3 14.9"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2 2.7H4.5L6.6 4.7"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  </CircledIcon>
);
